import { AreaChart } from "../../../shared/Charts";

const CHART_HEIGHT = 260;

/**
 * Driver leg activity chart with a fixed height so it does not blow out the Info tab layout.
 *
 * @param {{data?:Array, height?:number}} props
 */
const JobChart = ({ data, height = CHART_HEIGHT }) => {
  return (
    <div className="w-full" style={{ height }}>
      <AreaChart data={data} height={height} />
    </div>
  );
};

export default JobChart;
